import { Component } from '@angular/core';

@Component({
  selector: 'app-loading-button',
  imports: [],
  templateUrl: './loading-button.html',
  styleUrl: './loading-button.scss'
})
export class LoadingButton {

}
